export default __webpack_public_path__ + "static/media/mountain-lake.be498fd39c74bed619254d5704efa26e.svg";